export enum MainTabEnum {
  COINS = 'COINS',
  INCOGNITO = 'INCOGNITO',
  BOOST = 'BOOST',
}
